import { Typography, Stack, Chip } from "@mui/material";
import { Project } from "./ProjectSection";
import TerminalIcon from '@mui/icons-material/Terminal';
import { DesignServices, EditNotifications } from "@mui/icons-material";
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import useIsMobile from "../AppHelpers";

export interface ProjectCardProps{
    project:Project
}

const ProjectCard = (project: ProjectCardProps)=> {
       const isMobile = useIsMobile()
    const getIcon = (type:string)=>{
        
        switch (type.toLowerCase()){
            case 'software' :
                return <TerminalIcon color="primary" fontSize='large'></TerminalIcon>
            case 'design' :
                return <DesignServices color="primary" fontSize='large'></DesignServices>
            case 'craft': 
                return <ViewInArIcon color="primary" fontSize='large'></ViewInArIcon>
            case 'game':
                return <SportsEsportsIcon color="primary" fontSize="large"></SportsEsportsIcon>
            default:
             return   <EditNotifications color="primary" fontSize='large'></EditNotifications>
            
        }
       } 

    
    return (
           <Stack direction={'column'} sx={{backgroundColor:"antiqueWhite", textAlign:'left', padding:'2rem', width:'73vw', marginTop:'2rem'}}>
                <Stack direction={'row'} >
                    {getIcon(project.project.type)} 
                     <Stack direction={'column'} sx={{marginLeft:'0.5rem'}}> 
                        <Typography variant='h5' color="primary" >{project.project.name}</Typography>
                        <Typography variant="h6" color="#420A02" >{project.project.type}</Typography>
                      {!isMobile &&  <Typography variant="body2" fontFamily={'Helvetica Neue'} color="#420A02">{project.project.shortDescription}</Typography>}
                        {project.project.technologies && <>
                            <Stack direction="row">
                                <Typography variant="caption" fontFamily={'Helvetica Neue'} color="primary">Technologies Used: {project.project.technologies.join(', ')}</Typography>
                            </Stack>
                        </>}        
                </Stack>
                <Chip label={project.project.status} variant={project.project.status === 'Completed' ? 'filled': 'outlined'} color="primary" sx={{marginRight:0, marginLeft:'auto'}}></Chip>
            </Stack>

        </Stack>
    );
  }
  
  export default ProjectCard;